import { Box, IconButton, Theme, Typography, useMediaQuery, useTheme, Breadcrumbs } from '@mui/material';
import { LOGO } from '../../Helpers/constants';
import { ReactNode } from 'react';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { getFirstLetters } from '../../Utils/helperFunctions';
import { makeStyles } from '@mui/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LogoutIcon from '@mui/icons-material/Logout';

const useStyles = makeStyles((theme: Theme) => ({
  page: {
    background: '#F6F8FB',
    height: '100vh',
    overflow: 'hidden',
    padding: '40px',
    [theme.breakpoints.down('md')]: {
      background: '#FFF',
      padding: '0px',
      overflow: 'auto',
      overflowX: 'hidden',
    },
  },
  headerFrame: {
    borderBottom: '2px solid #F0EDF6',
    paddingBottom: '14px',
    [theme.breakpoints.down('md')]: {
      padding: '8px',
    },
  },
  avatar: {
    height: '48px',
    width: '48px',
    borderRadius: '50px',
    background: '#fff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    cursor: 'pointer',
  },
}));

const AppLayout: React.FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const classes = useStyles();
  const theme = useTheme();
  const { pathname, state } = useLocation();
  const navigate = useNavigate();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));
  const data = sessionStorage.getItem('user') ? JSON.parse(`${sessionStorage.getItem('user')}`) : null;
  const headerName = pathname.split('/')[1];
  const isHome = headerName === 'home';

  return (
    <Box component={'section'} className={`w-100 ${classes.page}`}>
      <Box component={'div'} className={`w-100 d-flex justify-content-between align-items-center ${classes.headerFrame}`}>
        {!isHome && isMobileScreen ? (
          <IconButton
            onClick={() => {
              navigate(-1);
            }}
          >
            <ArrowBackIcon sx={{ fontSize: '20px', color: '#545454' }} />
          </IconButton>
        ) : (
          <Box component={'div'} className="d-flex flex-column align-items-start gap-2">
            {/* Logo Section */}
            <Box component={'div'} className="d-flex align-items-center gap-3">
              <Box
                component={'div'}
                sx={{
                  background: '#fff',
                  padding: '4px',
                }}
              >
                <Box component={'img'} src={LOGO} sx={{ height: '32px', width: 'auto' }} />
              </Box>
              {!isMobileScreen && (
                <Typography component={'h6'} variant="largebold" color={'#333333'}>
                  in 5
                </Typography>
              )}
            </Box>

            {/* Breadcrumbs Section */}
            {!isHome && (
              <Box
                component="div"
                sx={{
                  marginTop: '8px',
                }}
              >
                <Breadcrumbs
                  aria-label="breadcrumb"
                  separator=">"
                  sx={{
                    '& .MuiBreadcrumbs-separator': { color: '#4B3776' },
                  }}
                >
                  {/* Static Dashboard link */}
                  <Typography
                    color="inherit"
                    sx={{ fontWeight: 'normal', cursor: 'pointer' }}
                    onClick={() => navigate('/')}
                  >
                    Dashboard
                  </Typography>

                  {/* Dynamic Current Page */}
                  <Typography color="#4B3776" sx={{ fontWeight: 'bold' }}>
                  Application {state?.breadCrumbs || headerName}
                  </Typography>
                </Breadcrumbs>
              </Box>
            )}
          </Box>
        )}
        {!isHome && isMobileScreen && (
          <Typography sx={{ textTransform: 'capitalize' }} color={'#333333'} variant="smallmedium">
            {state?.breadCrumbs || headerName}
          </Typography>
        )}
        <Box component={'div'} className="d-flex align-items-center" gap={'18px'}>
          {/* <CalendarTodayOutlinedIcon sx={{ fontSize: isMobileScreen ? '20px' : '32px' }} />
          <NotificationsOutlinedIcon sx={{ fontSize: isMobileScreen ? '20px' : '32px' }} /> */}
          {!isMobileScreen && (
            <Box component={'div'} className="d-flex align-items-center" gap={'18px'}>
              <Box component={'div'} className={classes.avatar}>
                <Typography component={'h6'} variant="largemedium" color={'#604797'} textAlign={'center'}>
                  {getFirstLetters(data?.applicantName)}
                </Typography>
              </Box>
              <Typography component={'h6'} variant="largemedium" color={'#333333'}>
                {data?.applicantName}
              </Typography>
            </Box>
          )}
          {!isMobileScreen && (
            <Box
              component={'div'}
              className="d-flex align-items-center"
              sx={{ gap: '4px', background: '#E6E6E6', borderRadius: '8px', padding: '8px 16px', cursor: 'pointer' }}
              onClick={() => {
                sessionStorage.clear();
                localStorage.clear();
                navigate('/');
              }}
            >
              <Typography variant="medium" color={'#333333'}>
                Logout
              </Typography>
              <LogoutIcon sx={{ color: '#333333', fontSize: '20px' }} />
            </Box>
          )}
        </Box>
      </Box>
      <Box component={'div'} sx={{ paddingTop: isMobileScreen ? '0px' : '20px' }}>
        {children}
      </Box>
    </Box>
  );
};

export default AppLayout;
